import { SET_JSD_WIDGET_READY } from "./actionTypes";

export const setJSDWidgetReady = () => ({
  type: SET_JSD_WIDGET_READY,
});
